import MeioPagView from "./view/meiopg.list"

export const MeioPagList = MeioPagView